import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "../calendar/CustomDay.css";
var CustomDayTimeLog = function (_a) {
    var date = _a.date, events = _a.events, onClick = _a.onClick;
    var totalCost = events
        .filter(function (event) {
        var eventDate = new Date(event.start).toDateString();
        return eventDate === date.toDateString();
    })
        .reduce(function (sum, event) {
        return sum + (event.content ? parseFloat(event.content) : 0);
    }, 0);
    return (_jsxs("div", { className: "flex items-center justify-start h-full w-full rounded-full flex-col pt-1", onClick: onClick, children: [_jsx("span", { children: date.getDate() }), totalCost > 0 && (_jsx("div", { className: "px-2", children: _jsxs("span", { className: "bg-green-700 text-white text-xs px-2", children: ["$", totalCost.toFixed(2)] }) }))] }));
};
export default CustomDayTimeLog;
